import React from "react";
import MainLayout from "../../../components/MainLayout";
import AdministradorOperacion from "./components/AdministradorOperacion"
import { Link } from "react-router-dom";
import TabAdminAaaver from "../ListadoAgentes/TabAdminAaaver";

const DetalleOperacion = () => {

  const role = localStorage.getItem('role');
  
  return (
    <MainLayout>
      <div className="row title_layout">
        <div className="col-6">
          <h5>DETALLES DE OPERACIÓN</h5>
        </div>
        { role === 'ASC' &&
        <div className="col-6 d-flex flex-row-reverse">
          <TabAdminAaaver />
        </div>
        }
      </div>
      <AdministradorOperacion />
    </MainLayout>
  );
};

export default DetalleOperacion;
